module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/assign.js
// module id = ./node_modules/babel-runtime/core-js/object/assign.js
// module chunks = 168707334958949